import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { CTABand } from "../components/CTABand";
import { StatsStrip } from "../components/StatsStrip";
import { Reveal } from "../components/Reveal";
import { IconArrow } from "../components/Icons";
import { getPage } from "../lib/api";

const SUBPAGES = [
  { path: "/about/who-we-are", num: "01", title: "Who We Are", desc: "Our background, purpose, market role, and professional identity." },
  { path: "/about/mission-and-values", num: "02", title: "Mission & Values", desc: "What drives us and the principles we uphold in every engagement." },
  { path: "/about/why-lemur-quality", num: "03", title: "Why Lemur Quality", desc: "The strengths and commitments that set our work apart." },
  { path: "/about/our-approach", num: "04", title: "Our Approach", desc: "Our structured path from assessment to continuous improvement." },
];

export default function About() {
  const [page, setPage] = useState(null);
  useEffect(() => { getPage("about").then(setPage).catch(() => {}); }, []);

  return (
    <div data-testid="about-page">
      <PageHeader eyebrow={page?.eyebrow || "About Lemur Quality"} title={page?.title || "Specialists in quality, compliance, and operational trust"} lead={page?.lead} crumb="About" />
      <StatsStrip />

      <section className="section bg-paper">
        <div className="wrap">
          <Reveal className="d-lead" style={{ marginBottom: 40 }}>
            {page?.sections?.map((s, i) => (
              <div key={i}>{s.paragraphs.map((p, j) => <p key={j}>{p}</p>)}</div>
            ))}
          </Reveal>

          <div className="hub-grid" data-testid="about-subpages">
            {SUBPAGES.map((s, i) => (
              <Reveal key={s.path} delay={(i % 2) * 70}>
                <Link to={s.path} className="hub-card" data-testid={`about-card-${s.path.split("/").pop()}`}>
                  <span className="hc-num">{s.num}</span>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                  <span className="more">Read more <IconArrow /></span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
